<div class="dialog-wrapper">
    <div class="header">
        <img
            [src]="iconPath"
            alt="dialog-icon"
        />
        <p>
            {{
                injectedData.headerTranslationKey
                    | translate: injectedData.headerInterpolateParameters
            }}
        </p>
    </div>
    <div class="question-text" *ngIf="injectedData.confirmationQuestion">
        <p
            [innerHTML]="
                injectedData.confirmationQuestion.translationKey
                    | translate: injectedData.confirmationQuestion.interpolateParameters
            "
        ></p>
    </div>
    <div
        class="question-text"
        *ngIf="injectedData.bodyLines && injectedData.bodyLines.length"
    >
        <ng-container *ngFor="let line of injectedData.bodyLines">
            <p
                *ngIf="line.style !== 'bold-bullet'"
                class="body-line"
                [class.highlighted]="line.style === 'highlighted'"
                [innerHTML]="line.translationKey | translate: line.interpolateParameters"
            ></p>
            <ul *ngIf="line.style === 'bold-bullet'" class="error-list">
                <li
                    class="bold-bullet"
                    [innerHTML]="line.translationKey | translate: line.interpolateParameters"
                ></li>
            </ul>
        </ng-container>
    </div>
    <div class="action-buttons">
        <button (click)="onSubmit()" class="confirm-button" *ngIf="injectedData.confirmButtonTranslationKey">
            {{ injectedData.confirmButtonTranslationKey | translate }}
        </button>
        <button (click)="onCancel()" class="cancel-button" *ngIf="injectedData.rejectButtonTranslationKey">
            {{ injectedData.rejectButtonTranslationKey | translate }}
        </button>
    </div>
</div>
